import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import svelteComponent from "./MediaObjectCardV2.svelte";

defineComponent({
  tag: "oc-media-object-card-v2",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: () => import("./MediaObjectCardV2.global.scss?inline"),
  props: {
    elevationLevel: { attribute: "elevation-level", reflect: true },
    icon: { reflect: true },
    inverted: { type: "Boolean", reflect: true, default: false },
    preferVerticalAlignment: {
      type: "Boolean",
      attribute: "prefer-vertical-alignment",
      reflect: true,
    },
    singleLine: { type: "Boolean", attribute: "single-line", reflect: true },
    size: { reflect: true },
    variant: { reflect: true },
    widthBehavior: { attribute: "width-behavior", reflect: true },
  },
  component: () => svelteComponent,
});
